export default function sortGroupByVisitTime(list) {
  let newList = [...list];
  return newList.sort((a, b) => {
    a = +a.visitingTime.split(":").join("");
    b = +b.visitingTime.split(":").join("");
    return a - b;
  });
}
